<template>
  <v-container
    fluid
    @contextmenu="show"
    :style="{ 'background-color': widget.background_color }"
  >
    <InfoAlert
      :showDismissibleAlert="showDismissibleAlert"
      v-on:close="showDismissibleAlert = false"
      :info="info"
    />

    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      @click="dialog = true"
      v-if="$store.state.settingMode"
    >
      <v-list
        :dark="$store.getters.getColorPalette().isDark"
        :color="$store.getters.getColorPalette().backgroundColorCode"
      >
        <v-list-item @click="update = true">
          <v-list-item-title
            ><strong>{{
              $store.getters.getTextMap().edit
            }}</strong></v-list-item-title
          >
          <v-list-item-icon>
            <v-icon small>mdi-pencil</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item @click="deleteWidget">
          <v-list-item-title
            ><strong
              >{{ $store.getters.getTextMap().delete }}
            </strong></v-list-item-title
          >
          <v-list-item-icon>
            <v-icon color="red" small>mdi-trash-can</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog
      v-model="update"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card
        :dark="$store.getters.getColorPalette().isDark"
        :color="$store.getters.getColorPalette().backgroundColorCode"
      >
        <v-toolbar
          :dark="$store.getters.getColorPalette().isDark"
          :color="$store.getters.getColorPalette().foregroundColorCode"
        >
          <v-btn
            icon
            :dark="$store.getters.getColorPalette().isDark"
            @click="update = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ widget.label }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              :dark="$store.getters.getColorPalette().isDark"
              text
              @click="update = false"
              >{{ $store.getters.getTextMap().close }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <AddShiftBasedBarTrendWidget
          :widget="widget"
          v-on:close="update = false"
          :edit="edit"
          v-on:success="$emit('update')"
        />
      </v-card>
    </v-dialog>
    <v-skeleton-loader
      v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
    <v-row v-if="widget.meta" no-gutters>
      <v-col align="right">
        <v-btn-toggle
          :dark="$store.getters.getColorPalette().isDark"
          v-model="graphType"
          mandatory
          rounded
        >
          <v-btn small>{{ $store.getters.getTextMap().bar }} </v-btn>
          <v-btn small>{{ $store.getters.getTextMap().line }}</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <div
      v-if="widget.meta"
      ref="vis"
      :style="[
        widget.height === 'fixed'
          ? {
              'background-color': widget.background_color
                ? widget.background_color
                : $store.getters.getColorPalette().background2ColorCode,
              height: '150px',
            }
          : {},
      ]"
    ></div>
    <div
      v-else
      :style="[
        widget.height === 'fixed'
          ? { height: '175px', 'text-align': 'center' }
          : { 'text-align': 'center' },
      ]"
    >
      <v-icon small>mdi-hail</v-icon>
      <h5>{{ $store.getters.getTextMap().not_configured }}</h5>
    </div>
  </v-container>
</template>
<script>
import Plotly from "plotly.js";
import AddShiftBasedBarTrendWidget from "@/components/crud_components/widgets/AddShiftBasedBarTrendWidget";
import InfoAlert from "@/components/InfoAlert";
import axios from "axios";
import DateUtils from "@/utillities/DateUtils";
import moment from "moment";
export default {
  name: "ShiftBasedBarTrendWidget",
  components: {
    AddShiftBasedBarTrendWidget,
    InfoAlert,
  },
  props: {
    widget: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      file: "ShiftBasedBarTrendWidget.vue",
      info: "",
      showDismissibleAlert: false,
      showMenu: false,
      showDialog: false,
      x: 0,
      y: 0,
      update: false,
      dialog: false,
      loading: false,
      graphType: "bar",
      shiftData: [],
      paramData: [],
      widgetMetaParmData: [],
      layout: {
        font: { color: this.$store.getters.getColorPalette().accentCode },
        plot_bgcolor: this.widget.background_color
          ? this.widget.background_color
          : this.$store.getters.getColorPalette().background2ColorCode,
        paper_bgcolor: this.widget.background_color
          ? this.widget.background_color
          : this.$store.getters.getColorPalette().background2ColorCode,
        autosize: true,
        hoverlabel: { namelength: -1 },
        xaxis: {
          tickangle: -10,
          zeroline: false,
          showgrid: true,
          showticklabels: true,
          color: this.$store.getters.getColorPalette().accentCode,
        },
        yaxis: {
          range: [0, this.benchmarkYValue + 100],
          showticklabels: true,
          color: this.$store.getters.getColorPalette().accentCode,
        },
        uniformtext: {
          mode: "hide",
          minsize: 1,
        },
        borderCornerRadius: 25,
      },
    };
  },
  mounted() {
    if (
      this.widget &&
      this.widget.widget_id &&
      this.widget.meta &&
      this.widget.meta.paramsdata &&
      this.widget.meta.paramsdata.parameter.length > 0
    ) {
      this.graphType = this.widget.meta.graphType;

      this.getParamData();
    }
  },
  computed: {},
  methods: {
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      if (this.$store.state.settingMode) {
        this.$nextTick(() => {
          this.showMenu = true;
        });
      }
    },
    getDates() {
      let timeFrame = this.widget.meta.timeFrame
        ? this.widget.meta.timeFrame
        : 0;
      let dt = DateUtils.getFromDate(timeFrame);
      let from = dt.format("YYYY-MM-DD");
      let to = moment().format("YYYY-MM-DD");
      // console.log(from,to)
      return [from, to];
    },

    async loadShiftData() {
      if (this.widget && this.widget.meta && this.widget.meta.shift_id) {
        try {
          this.loading = true;
          let payload = {
            shift_id: this.widget.meta.shift_id,
          };
          let response = await axios.post(
            this.$store.state.api + "shiftData",
            payload,
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.jwt,
              },
            }
          );
          // console.log(response, "shift data response");

          if (response.data.status === "success") {
            this.shiftData = response.data.data;
          } else {
            this.info = "Unable to load shift Data";
          }
          this.loading = false;
        } catch (err) {
          this.loading = false;
          this.info = err;
          this.showDismissibleAlert = true;
        }
      }

      if (this.paramData.length > 0 && this.shiftData.length > 0) {
        this.createGraph();
      }
    },

    getParamDataPayload() {
      // console.log(this.widget, "widget");

      if (
        this.widget &&
        this.widget.widget_id &&
        this.widget.meta &&
        this.widget.meta.paramsdata &&
        this.widget.meta.paramsdata.parameter.length > 0
      ) {
        let from, to;
        [from, to] = this.getDates();
        let parameters = [];
        let paramMetaData = [];
        for (let param of this.widget.meta.paramsdata.parameter) {
          parameters.push(param.param_id);
          paramMetaData.push({
            param_name: param.name,
            param_id: param.param_id,
          });
        }
        this.widgetMetaParmData = paramMetaData;
        return {
          from_date: from,
          to_date: to,
          parameters: parameters,
          shift_id: this.widget.meta.shift_id,
        };
      }
    },

    getParamNameFromMetaParamData(param_id) {
      const matchedParam = this.widgetMetaParmData.find(
        (p) => p.param_id === param_id
      );
      // console.log(matchedParam,"matched param");
      
      return matchedParam.param_name;
    },

    async getParamData() {
      // console.log("getParamData called");
      try {
        this.loading = true;
        let payload = this.getParamDataPayload();

        let response = await axios.post(
          this.$store.state.api + "getParamShiftDataBetweenDate",
          payload,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.jwt,
            },
          }
        );
        // console.log(response, "param data response");

        if (response.data.status === "success") {
          this.paramData = response.data.data;
        } else {
          this.info = "Unable to load param Data";
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.info = err;
        this.showDismissibleAlert = true;
      }
      if (this.widget && this.widget.meta && this.widget.meta.shift_id) {
        this.loadShiftData();
      }
    },
    deleteWidget() {
      this.loading = true;
      axios
        .post(this.$store.state.api + "deleteWidget", this.widget, {
          headers: { Authorization: "Bearer " + this.$store.state.jwt },
        })
        .then((response) => {
          if (response.data.status === "success") {
            this.dialog = false;
            this.loading = false;
            this.$emit("update");
          }
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },

    createGraph() {
      // console.log(this.widgetMetaParmData, "metaparamData");
      // console.log(this.shiftData, "shiftData");
      // console.log(this.paramData,"paramData");
      
      const paramDataWithParamName = this.paramData.map((param) => {
        // console.log(param,"param");
        
        return {
          ...param,
          name: this.getParamNameFromMetaParamData(param.param_id),
        };
      });

      // console.log(paramDataWithParamName, "param with name");

      let traces = [];
      paramDataWithParamName.forEach((param) => {
        this.shiftData.forEach((shift) => {
          if (param.from_time === shift.from_time) {
            let d = {
              x: [
                `${
                  shift.name
                    ? shift.name
                    : shift.shift_name
                    ? shift.shift_name
                    : shift.msg
                } : ${shift.from_time} - ${shift.to_time}`,
              ],
              y: [param.usage],
              name: param.name,
              type: this.graphType === 1 ? "line" : "bar",
            };
            traces.push(d);
          }
        });
      });
      // console.log(traces, "traces");
      // console.log(this.graphType, "graphType");

      this.layout.title = {
        text: this.widget.label,
      };
      this.layout.xaxis.title = {
        text: this.widget.meta.xaxisLabel
          ? this.widget.meta.xaxisLabel
          : "Shift Timing",
      };

      // console.log(this.widget, "widger");

      this.layout.yaxis.title = {
        text: this.widget.meta.yaxisLabel
          ? this.widget.meta.yaxisLabel
          : "Usage",
      };

      Plotly.newPlot(this.$refs.vis, traces, this.layout, {
        displaylogo: false,
      });
    },
  },
  watch: {
    graphType: function () {
      this.createGraph();
    },
  },
};
</script>